export const VERIFICATION_STATUS = {
  NO_ENVIADA: 0,
  APROBADA: 1,
  RECHAZADA: 2,
  ENVIADA: 3
};